// extracted by mini-css-extract-plugin
export var container = "Laptop-module--container--15ba3";
export var screen = "Laptop-module--screen--67a6a";